<template>
    <v-dialog v-model="dialog" max-width="1280" >
        <template #activator="{on}">
            <v-btn outlined small v-on="on">
                <v-icon small left>mdi-pencil</v-icon>
                Edit
            </v-btn>
        </template>
        <v-card :loading="loading" :disabled="loading">
            <v-card-title>Use client address for {{ type }}</v-card-title>
            <v-card-text>
                <v-simple-table v-if="addresses.length">
                    <thead>
                        <tr>
                            <th></th>
                            <th>Company</th>
                            <th>Address</th>
                            <th>City</th>
                            <th>Country</th>
                            <th>Type</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="address in addresses" :key="address.id">
                            <td>
                                <v-chip color="warning" outlined small v-if="address.default">default</v-chip>
                            </td>
                            <td>{{ address.company }}</td>
                            <td>
                                {{ address.addressLine1 }}
                                <template v-if="address.addressLine2">
                                    <br> {{ address.addressLine2 }}
                                </template>
                            </td>
                            <td>
                                {{ address.postalCode }} {{ address.city }}
                            </td>
                            <td>
                                <template v-if="address.state">{{ address.state }} -</template>
                                {{ getCountryName(address.country) }}
                            </td>
                            <td>
                                {{ address.typeId }}
                            </td>
                            <td>
                                <v-btn small outlined class="mr-2" color="warning" @click="doMarkAsDefault(address)" :disabled="!!address.default">
                                    Mark as default
                                </v-btn>
                                <v-btn outlined small class="mr-2" @click="$refs.addressForm.doOpen(address)">
                                    <v-icon left>mdi-pencil</v-icon>
                                    Edit
                                </v-btn>
                                <v-btn color="accent" small @click="doUpdateOrderAddress(address)">
                                    <v-icon left>mdi-check</v-icon>
                                    Use
                                </v-btn>
                            </td>
                        </tr>
                    </tbody>
                </v-simple-table>
                <template v-else>
                    No addresse<br>
                    <v-btn color="accent" @click="$refs.addressForm.doOpen({})">Create address</v-btn>
                </template>
                <AddressForm
                    ref="addressForm"
                    :clientId="clientId"
                    @updated="refresh()"
                />
            </v-card-text>
            <v-card-actions>
                <v-btn outlined @click="dialog=false">cancel</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { getCountryName } from "@/utils/country.js"
import { mapActions, mapGetters } from 'vuex'
import AddressForm from "./CustomerAddressForm.vue"

export default {
    name: 'AddressSelection',
    components: { AddressForm },
    props:{
        type: {
            type:String,
            required: true
        },
        clientId: {
            type: Number,
            required: true
        },
        orderId: {
            type: Number,
            required: true
        }
    },
    data: () => ({
        dialog:false,
        addresses: []
    }),
    computed: {
        ...mapGetters('clientAddresses', {fetching: 'loading'}),
        loading () {
            return this.fetching
        }
    },
    methods: {
        ...mapActions('clientAddresses', {getAddresses: 'get', markAsDefault: 'markAsDefault'}),
        ...mapActions('orders', {updateOrderAddress: 'updateAddress'}),
        getCountryName,
        refresh () {
            this.load()
        },
        load() {
            this.getAddresses({id: this.clientId}).then(({addresses}) => this.addresses = addresses)
        },
        
        doMarkAsDefault(item) {
            this.markAsDefault(item)
            .then(() => this.load());
        },
        doUpdateOrderAddress(item) {
            this.updateOrderAddress({
                orderId: this.orderId,
                model: item,
                type: this.type
            }).then(() => {
                this.$emit('updated')
                this.dialog = false
            })
        }
    },
    watch: {
        dialog (v) {
            if(v){
                this.load()
            }
        }
    }
}

</script>